import {Divider, Paper} from '@material-ui/core';
import React from 'react';
import {toFormattedDateTime} from 'Shared/utilities/DateFormatter';
import {ETLStatus} from 'SystemAdministration/models/ETLStatus';
import './ETLCard.sass';
import CardField from 'Shared/components/CardField';

type ETLCardProps = {
  etlStatus: ETLStatus;
};

const ETLCard = (props: ETLCardProps) => {
  const {etlStatus} = props;
  const {elapsedTime, etlLoadEndDateTime, etlLoadStartDateTime, machineName, processName, status} = etlStatus;

  return (
    <Paper className="etl-status-card">
      <span className={`etl-status-card__status-icon--${status.toLowerCase()}`} />
      <span className="etl-status-card__title">{processName}</span>
      <Divider />
      <CardField name="Status" value={status} />
      <CardField name="Start Time" value={toFormattedDateTime(etlLoadStartDateTime)} />
      <CardField name="End Time" value={toFormattedDateTime(etlLoadEndDateTime)} />
      <CardField name="Elapsed Time" value={elapsedTime} />
      <CardField name="Machine Name" value={machineName} />
    </Paper>
  );
};

export default ETLCard;
